<div class="h-100" [ngClass]="compact ? 'pt-1 pb-3' : 'pt-3 pb-3'">
    <div class="d-flex gap-2">
        <div
            class="d-flex me-2 form-check form-switch form-check-input-container"
        >
            <input
                class="form-check-input"
                [ngClass]="{
                    'bg-primary border-primary': isEnabled,
                    'bg-secondary border-secondary': !isEnabled,
                }"
                type="checkbox"
                role="switch"
                [(ngModel)]="isEnabled"
                (ngModelChange)="onEnabledValueChange($event)"
            />
        </div>
        <div
            class="title weight-medium"
        >
            @if (icon) {
                <i [ngClass]="icon" class="me-1"></i>
            }
            {{ heading }}
        </div>
    </div>
    <div [ngClass]="panelClass">
        @switch (settingPanelType) {
            @case (SettingPanelType.Numeric) {
                @if (isTargetThreshold) {
                    <div
                        [ngClass]="{
                            'mt-2': !compact,
                        }"
                    >
                        <telxl-spinner-input
                            class="w-80"
                            label="Target"
                            [isEnabled]="isEnabled"
                            [minValue]="min"
                            [maxValue]="max"
                            [value]="teamValue.target"
                            [error]="!isValid && valueFieldChanged === 'T'"
                            [errorIcon]="showErrorIcon"
                            [errorMessage]="errorMessage"
                            [hasMaxInputWidth]="true"
                            (valueChange)="onTargetValueChange($event)"
                        />
                    </div>
                }

                <div
                    [ngClass]="{
                        'mt-2': !compact,
                    }"
                >
                    <telxl-spinner-input
                        class="w-80"
                        label="Low"
                        [isEnabled]="isEnabled"
                        [minValue]="min"
                        [maxValue]="max"
                        [value]="value.low"
                        [error]="!isValid && valueFieldChanged === 'L'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="onLowValueChange($event)"
                    />
                </div>

                <div
                    [ngClass]="{
                        'mt-2': !compact,
                    }"
                >
                    <telxl-spinner-input
                        class="w-80"
                        label="High"
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="max"
                        [value]="value.high"
                        [error]="!isValid && valueFieldChanged === 'H'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="onHighValueChange($event)"
                    />
                </div>
            }
            @case (SettingPanelType.Percentage) {
                @if (isTargetThreshold) {
                    <div
                        [ngClass]="{
                            'mt-2': !compact,
                        }"
                    >
                        <telxl-spinner-input
                            class="w-80"
                            label="Target"
                            [isEnabled]="isEnabled"
                            [minValue]="min"
                            [maxValue]="max"
                            [value]="teamValue.target * 100"
                            [error]="!isValid && valueFieldChanged === 'T'"
                            [errorIcon]="showErrorIcon"
                            [errorMessage]="errorMessage"
                            [hasMaxInputWidth]="true"
                            placeholder="%"
                            (valueChange)="onTargetValueChange($event)"
                        />
                    </div>
                }

                <div
                    [ngClass]="{
                        'mt-2': !compact,
                    }"
                >
                    <telxl-spinner-input
                        class="w-80"
                        label="Low"
                        [isEnabled]="isEnabled"
                        [minValue]="min"
                        [maxValue]="max"
                        [value]="value.low * 100"
                        [error]="!isValid && valueFieldChanged === 'L'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        placeholder="%"
                        (valueChange)="onLowValueChange($event)"
                    />
                </div>

                <div
                    [ngClass]="{
                        'mt-2': !compact,
                    }"
                >
                    <telxl-spinner-input
                        class="w-80"
                        label="High"
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="100"
                        [value]="value.high * 100"
                        [error]="!isValid && valueFieldChanged === 'H'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        placeholder="%"
                        (valueChange)="onHighValueChange($event)"
                    />
                </div>
            }
            @case (SettingPanelType.Time) {
                @if (isTargetThreshold) {
                    <div
                        class="w-100 d-flex justify-content-between gap-2"
                        [ngClass]="compact ? '' : 'mt-2'"
                    >
                        <telxl-spinner-input
                            label="Target"
                            [isEnabled]="isEnabled"
                            [minValue]="0"
                            [maxValue]="31"
                            [value]="
                                secondsToDuration(this.teamValue.target).days ??
                                0
                            "
                            [error]="!isValid && timeFieldChanged === 'TD'"
                            [errorIcon]="showErrorIcon"
                            [errorMessage]="errorMessage"
                            [hasMaxInputWidth]="true"
                            placeholder="D"
                            [twoDigit]="true"
                            (valueChange)="
                                onTargetValueTimeChange({
                                    type: 'D',
                                    newValue: $event,
                                })
                            "
                        />
                        <telxl-spinner-input
                            [isEnabled]="isEnabled"
                            [minValue]="0"
                            [maxValue]="23"
                            [value]="
                                secondsToDuration(this.teamValue.target)
                                    .hours ?? 0
                            "
                            [error]="!isValid && timeFieldChanged === 'TH'"
                            [errorIcon]="showErrorIcon"
                            [errorMessage]="errorMessage"
                            [hasMaxInputWidth]="true"
                            placeholder="H"
                            [twoDigit]="true"
                            (valueChange)="
                                onTargetValueTimeChange({
                                    type: 'H',
                                    newValue: $event,
                                })
                            "
                        />
                        <telxl-spinner-input
                            [isEnabled]="isEnabled"
                            [minValue]="0"
                            [maxValue]="59"
                            placeholder="M"
                            [twoDigit]="true"
                            [value]="
                                secondsToDuration(this.teamValue.target)
                                    .minutes ?? 0
                            "
                            [error]="!isValid && timeFieldChanged === 'TM'"
                            [errorIcon]="showErrorIcon"
                            [errorMessage]="errorMessage"
                            [hasMaxInputWidth]="true"
                            (valueChange)="
                                onTargetValueTimeChange({
                                    type: 'M',
                                    newValue: $event,
                                })
                            "
                        />
                        <telxl-spinner-input
                            [isEnabled]="isEnabled"
                            [minValue]="0"
                            [maxValue]="59"
                            placeholder="S"
                            [twoDigit]="true"
                            [value]="
                                secondsToDuration(this.teamValue.target)
                                    .seconds ?? 0
                            "
                            [error]="!isValid && timeFieldChanged === 'TS'"
                            [errorIcon]="showErrorIcon"
                            [errorMessage]="errorMessage"
                            [hasMaxInputWidth]="true"
                            (valueChange)="
                                onTargetValueTimeChange({
                                    type: 'S',
                                    newValue: $event,
                                })
                            "
                        />
                    </div>
                }

                <div
                    class="w-100 d-flex justify-content-between gap-2"
                    [ngClass]="compact ? '' : 'mt-2'"
                >
                    <telxl-spinner-input
                        label="Low"
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="31"
                        [value]="secondsToDuration(this.value.low).days ?? 0"
                        [error]="!isValid && timeFieldChanged === 'LD'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        placeholder="D"
                        [twoDigit]="true"
                        (valueChange)="
                            onLowValueTimeChange({
                                type: 'D',
                                newValue: $event,
                            })
                        "
                    />
                    <telxl-spinner-input
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="23"
                        [value]="secondsToDuration(this.value.low).hours ?? 0"
                        [error]="!isValid && timeFieldChanged === 'LH'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        placeholder="H"
                        [twoDigit]="true"
                        (valueChange)="
                            onLowValueTimeChange({
                                type: 'H',
                                newValue: $event,
                            })
                        "
                    />
                    <telxl-spinner-input
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="59"
                        placeholder="M"
                        [twoDigit]="true"
                        [value]="secondsToDuration(this.value.low).minutes ?? 0"
                        [error]="!isValid && timeFieldChanged === 'LM'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="
                            onLowValueTimeChange({
                                type: 'M',
                                newValue: $event,
                            })
                        "
                    />
                    <telxl-spinner-input
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="59"
                        placeholder="S"
                        [twoDigit]="true"
                        [value]="secondsToDuration(this.value.low).seconds ?? 0"
                        [error]="!isValid && timeFieldChanged === 'LS'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="
                            onLowValueTimeChange({
                                type: 'S',
                                newValue: $event,
                            })
                        "
                    />
                </div>

                <div class="w-100 mt-2 d-flex justify-content-between gap-2">
                    <telxl-spinner-input
                        label="High"
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="31"
                        placeholder="D"
                        [twoDigit]="true"
                        [value]="secondsToDuration(this.value.high).days ?? 0"
                        [error]="!isValid && timeFieldChanged === 'HD'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="
                            onHighValueTimeChange({
                                type: 'D',
                                newValue: $event,
                            })
                        "
                    />
                    <telxl-spinner-input
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="23"
                        placeholder="H"
                        [twoDigit]="true"
                        [value]="secondsToDuration(this.value.high).hours ?? 0"
                        [error]="!isValid && timeFieldChanged === 'HH'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="
                            onHighValueTimeChange({
                                type: 'H',
                                newValue: $event,
                            })
                        "
                    />
                    <telxl-spinner-input
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="59"
                        placeholder="M"
                        [twoDigit]="true"
                        [value]="
                            secondsToDuration(this.value.high).minutes ?? 0
                        "
                        [error]="!isValid && timeFieldChanged === 'HM'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="
                            onHighValueTimeChange({
                                type: 'M',
                                newValue: $event,
                            })
                        "
                    />
                    <telxl-spinner-input
                        [isEnabled]="isEnabled"
                        [minValue]="0"
                        [maxValue]="59"
                        placeholder="S"
                        [twoDigit]="true"
                        [value]="
                            secondsToDuration(this.value.high).seconds ?? 0
                        "
                        [error]="!isValid && timeFieldChanged === 'HS'"
                        [errorIcon]="showErrorIcon"
                        [errorMessage]="errorMessage"
                        [hasMaxInputWidth]="true"
                        (valueChange)="
                            onHighValueTimeChange({
                                type: 'S',
                                newValue: $event,
                            })
                        "
                    />
                </div>
                @if (!showErrorIcon && !isValid) {
                    <div class="text-danger font-sm">{{ errorMessage }}</div>
                }
            }
        }
    </div>
</div>
